import { useEffect, useState } from 'react';
import { Disclosure, Heading } from 'react-aria-components';
import { useParams } from 'react-router-dom';

import { useAtom } from 'jotai';

import { getPerformanceRecordsByChildIDForLine } from '@/api/getPerformanceRecordsByChildIDForLine';
import Button from '@/components/Button/Button';
import { UpdateDialog } from '@/components/user/performances/UpdateDialog';
import { LineUserAtom } from '@/jotai/jotai';
import { formattedDate } from '@/logics/date/date';
import { PerformanceRecord } from '@/types/performanceRecord';

const PerformancePage = () => {
  const [lineUser, _] = useAtom(LineUserAtom);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [status, setStatus] = useState<'approved' | 'rejected'>('approved');
  const [performanceRecords, setPerformanceRecords] = useState<PerformanceRecord[]>([]);
  const params = useParams<{ id: string }>();
  const childID = Number(params.id);

  useEffect(() => {
    if (childID && lineUser) {
      fetchPerformanceRecords();
    }
  }, [lineUser]);

  const fetchPerformanceRecords = async () => {
    const result = await getPerformanceRecordsByChildIDForLine(
      childID,
      lineUser?.accessToken ?? ''
    );
    if (result.status === 200) {
      console.log(result.result);
      setPerformanceRecords(result.result);
    }
  };

  return (
    <div className="m-4 space-y-4">
      <Heading className="text-2xl font-bold">実績記録票</Heading>

      <div className="rounded-8 bg-blue-100 px-2 py-3">
        <Heading className="text-lg font-bold">
          {performanceRecords.length > 0
            ? performanceRecords[0].child_name
            : '実績記録はありません'}
        </Heading>
      </div>

      {performanceRecords.map((record) => (
        <div
          key={record.id}
          className="rounded-8 bg-white p-4 shadow"
        >
          <Disclosure className="h-full rounded-md bg-gray-100">
            <div className="space-y-4 p-4">
              <div className="text-base font-bold">登録日</div>
              <div className="text-base">
                {formattedDate(new Date(record.published_at!), 'yyyy年M月dd日')}
              </div>
              <hr className="border-gray-400" />
            </div>

            <div className="space-y-4 p-4">
              <div className="text-base font-bold">詳細</div>
              <a
                href={record.pdf_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-base underline"
              >
                {formattedDate(new Date(record.published_at!), 'yyyy年M月dd日')}
              </a>
              <Button
                className="w-full"
                variant={`${record.status === 'published' ? 'solid-fill' : 'disabled'}`}
                size="lg"
                type="submit"
                disabled={record.status !== 'published'}
                onClick={() => {
                  setIsOpen(true);
                  setStatus('approved');
                }}
              >
                承認する
              </Button>
              <Button
                className="w-full"
                variant={`${record.status === 'published' ? 'text' : 'disabled'}`}
                size="lg"
                disabled={record.status !== 'published'}
                onClick={() => {
                  setIsOpen(true);
                  setStatus('rejected');
                }}
              >
                差戻し
              </Button>
              <hr className="border-gray-400" />
            </div>
          </Disclosure>
          {isOpen && (
            <UpdateDialog
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              afterSubmit={() => {
                fetchPerformanceRecords();
              }}
              childID={childID}
              performanceRecordID={record.id}
              status={status}
              lineAccessToken={lineUser?.accessToken ?? ''}
              target={formattedDate(new Date(record.published_at!), 'yyyy年M月dd日')}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default PerformancePage;
